__turbopack_context__.v({
  "list": "fCDPZG_list",
  "roleBlock": "fCDPZG_roleBlock",
  "viewAll": "fCDPZG_viewAll",
});
